type PlaygroundEMR = [
  injectorKey: string,
  pageInfoURL: string,
  scenarioPrefix: string
];

const playgroundHosts = new Set([
  'playground.comprehendpt.ai',
  'localhost',
  '127.0.0.1'
]);

const playgroundEMRs: Record<string, PlaygroundEMR> = {
  'https://app.webpt.com': ['app.webpt.com', 'https://app.webpt.com', 'webpt'],
  'https://emr.webpt.com': ['emr.webpt.com', 'https://emr.webpt.com', 'webpt2'],
  'https://demo.stridethera.com': [
    'stridethera.com',
    'stridethera.com',
    'stride'
  ],
  'https://test2-insight.clinicient.com': [
    'insight.clinicient.com',
    'https://insight.clinicient.com',
    'clinicient'
  ],
  'https://sapphire-uat.corahealth.com': [
    'corahealth.com',
    'https://sapphire.corahealth.com',
    'cora'
  ],
  'https://ehr2.charmtracker.com': [
    'charmtracker.com',
    'charmtracker.com',
    'charm-health'
  ],
  'https://go.promptemr.com': [
    'go.promptemr.com',
    'https://go.promptemr.com',
    'prompt'
  ]
};

function getPlaygroundContext(documentUrl: string, injectorKey: string | null) {
  try {
    const pageUrl = new URL(documentUrl);
    const emr = playgroundEMRs[pageUrl.searchParams.get('pgcx') || ''];
    if (!playgroundHosts.has(pageUrl.hostname) || !emr) return null;

    const [expectedInjectorKey, pageInfoURL, scenarioPrefix] = emr;
    const scenario = pageUrl.searchParams.get('pgscenario');
    const isInitialReplay = pageUrl.pathname.includes(
      `/r/${expectedInjectorKey}/`
    );
    const isCanonicalReplay =
      pageUrl.hash === `#${expectedInjectorKey}` &&
      scenario?.startsWith(`${scenarioPrefix}/`);
    if (
      injectorKey !== expectedInjectorKey ||
      (!isInitialReplay && !isCanonicalReplay)
    ) {
      return null;
    }

    pageUrl.searchParams.delete('pgcx');
    return { pageInfoURL, pageUrl: pageUrl.toString() };
  } catch {
    return null;
  }
}

export function normalizePlaygroundPageInfo(
  response,
  documentUrl: string,
  injectorKey: string | null
) {
  try {
    if (!response || typeof response !== 'object') return response;
    const playground = getPlaygroundContext(documentUrl, injectorKey);
    return playground ? { ...response, URL: playground.pageInfoURL } : response;
  } catch {
    return response;
  }
}

export function normalizePlaygroundPageUrl(
  documentUrl: string,
  injectorKey: string | null
) {
  try {
    return (
      getPlaygroundContext(documentUrl, injectorKey)?.pageUrl || documentUrl
    );
  } catch {
    return documentUrl;
  }
}
